import * as React from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

/** Native select (keyboard and screen readers work as people expect), styled like Input. */
export const Select = React.forwardRef<HTMLSelectElement, React.SelectHTMLAttributes<HTMLSelectElement>>(({ className, children, ...props }, ref) => (
  <span className={cn("relative inline-flex w-full", className)}>
    <select
      ref={ref}
      className="h-8 w-full appearance-none rounded-md border border-[var(--color-input)] bg-[var(--color-card)] py-1 pl-2.5 pr-7 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-ring)] disabled:opacity-50"
      {...props}
    >
      {children}
    </select>
    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 size-3.5 -translate-y-1/2 text-[var(--color-muted-foreground)]" />
  </span>
));
Select.displayName = "Select";
